import React from 'react';
import { Navigate } from 'react-router-dom';
import { ListingRoute } from '../../../../../models';
import BusinessInfo from './pages/BusinessInfo';
import StatementOfInformation from './pages/StatementOfInformation';

export default [
  {
    path: 'business-info',
    element: BusinessInfo,
    labelId: 'businessInfoLabelId',
  },
  {
    path: 'statement-of-information',
    labelId: 'statementOfInformationLabelId',
    element: StatementOfInformation,
  },
  { index: true, element: <Navigate to="business-info" replace /> },
] as Array<ListingRoute>;
